// src/utils/acciones.js

import { API_URL } from "../config";
import { getStudentCourseTemario } from "./studentCourseDataCache";
import { getCurrentUserProfile } from "./profileCache";

const headersConToken = () => ({
  "Content-Type": "application/json",
});

// 🔹 1. CREAR CURSO
export const crearCurso = async ({
  titulo,
  descripcion,
  duracion,
  precio,
  descuento,
  precioFinal,
  codigoDescuento,
  contenido,
  tests,
  pestanasCurso,
  imagen,
  publicadoAlumnos,
  esAbierto,
  fechaCierre,
  contenidoDescargable,
}) => {
  try {
    const response = await fetch(`${API_URL}/cursos`, {
      method: "POST",
      headers: headersConToken(),
      credentials: "include", // ✅ Cookie
      body: JSON.stringify({
        titulo,
        descripcion,
        duracion,
        precio,
        descuento,
        precioFinal,
        codigoDescuento,
        contenido,
        tests,
        pestanasCurso,
        imagen,
        publicadoAlumnos,
        esAbierto,
        fechaCierre,
        contenidoDescargable,
      }),
    });

    const data = await response.json();
    console.log("Respuesta de la API:", data); // 👀 Verifica la estructura en la consola

    return data;
  } catch (error) {
    console.error("Error en crearCurso:", error);
    return null;
  }
};


// 🔹 2. ELIMINAR CURSO
export const eliminarCurso = async (cursoId) => {
  try {
    const response = await fetch(`${API_URL}/cursos/${cursoId}`, {
      method: "DELETE",
      credentials: "include" // ✅ Cookie
    });

    const data = await response.json();
    if (response.ok) {
      alert("Curso eliminado con éxito");
    } else {
      alert("Error al eliminar curso: " + data.error);
    }
  } catch (error) {
    console.error("Error al eliminar curso:", error);
  }
};

// 🔹 3. PUBLICAR DOCUMENTO
export const publicarDocumento = async (titulo, contenido) => {
  try {
    const response = await fetch(`${API_URL}/documentos`, {
      method: "POST",
      headers: headersConToken(),
      credentials: "include", // ✅ Cookie
      body: JSON.stringify({ titulo, contenido }),
    });

    const data = await response.json();
    if (response.ok) {
      alert("Documento publicado con éxito");
    } else {
      alert("Error al publicar documento: " + data.error);
    }
  } catch (error) {
    console.error("Error al publicar documento:", error);
  }
};

// 🔹 4. ELIMINAR USUARIO
export const eliminarUsuario = async (idUsuario) => {
  try {
    const response = await fetch(`${API_URL}/usuarios/${idUsuario}`, {
      method: "DELETE",
      credentials: "include" // ✅ Cookie
    });

    const data = await response.json();
    if (response.ok) {
      alert("Usuario eliminado con éxito");
    } else {
      alert("Error al eliminar usuario: " + data.error);
    }
  } catch (error) {
    console.error("Error al eliminar usuario:", error);
  }
};

// 🔹 5. EDITAR INFORMACIÓN DEL USUARIO
export const editarUsuario = async (idUsuario, nuevosDatos) => {
  try {
    const response = await fetch(`${API_URL}/usuarios/${idUsuario}`, {
      method: "PUT",
      headers: headersConToken(),
      credentials: "include", // ✅ Cookie
      body: JSON.stringify(nuevosDatos),
    });

    const data = await response.json();
    if (response.ok) {
      alert("Usuario actualizado con éxito");
    } else {
      alert("Error al actualizar usuario: " + data.error);
    }
  } catch (error) {
    console.error("Error al actualizar usuario:", error);
  }
};

// 🔹 6. INSCRIBIR USUARIO A CURSO
export const inscribirUsuario = async (usuarioId, cursoId) => {
  try {
    const response = await fetch(`${API_URL}/inscribir`, {
      method: "POST",
      headers: headersConToken(),
      credentials: "include", // ✅ Cookie
      body: JSON.stringify({ usuarioId, cursoId }),
    });

    const data = await response.json();
    if (response.ok) {
      alert("Usuario inscrito con éxito");
    } else {
      alert("Error al inscribir usuario: " + data.error);
    }
  } catch (error) {
    console.error("Error al inscribir usuario:", error);
  }
};

// 🔹 7. BLOQUEAR / DESBLOQUEAR USUARIO (estado explícito; el API ya no hace toggle)
export const bloquearUsuario = async (idUsuario, bloqueado = true) => {
  if (typeof bloqueado !== "boolean") {
    console.error("bloquearUsuario: el segundo argumento debe ser boolean (true = bloquear, false = desbloquear)");
    return;
  }
  try {
    const response = await fetch(`${API_URL}/usuarios/${idUsuario}/bloquear`, {
      method: "PATCH",
      headers: headersConToken(),
      credentials: "include",
      body: JSON.stringify({ bloqueado }),
    });

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    const isJson = contentType.includes("application/json");
    let data = null;
    if (response.status !== 204 && isJson) {
      try {
        data = await response.json();
      } catch {
        data = null;
      }
    }
    if (data == null) {
      data = {};
    }

    if (response.ok) {
      alert(bloqueado ? "Usuario bloqueado con éxito" : "Usuario desbloqueado con éxito");
    } else {
      const fromBody =
        typeof data === "object" && data !== null && typeof data.error === "string" && data.error.trim() !== ""
          ? data.error.trim()
          : "";
      alert("Error al actualizar el bloqueo: " + (fromBody || String(response.status)));
    }
  } catch (error) {
    console.error("Error al actualizar el bloqueo del usuario:", error);
  }
};

// 🔹 8. OBTENER INFORMACION PARA REFLEJAR EN EL PERFIL
export const obtenerPerfilUsuario = async (id) => {
  if (!id) {
    return getCurrentUserProfile();
  }

  const url = `${API_URL}/usuarios/${id}`;

  const response = await fetch(url, {
    credentials: "include" // ✅ Cookie
  });

  if (!response.ok) {
    console.error(`Error al obtener el perfil (ID: ${id || "actual"}):`, response.status);
    return null;
  }

  return await response.json();
};

export const actualizarPerfil = async (payload) => {
  const response = await fetch(`${API_URL}/perfil`, {
    method: "PUT",
    headers: headersConToken(),
    credentials: "include", // ✅ Cookie
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    console.error("Error al actualizar el perfil:", response.status);
    return null;
  }
  return await response.json();
};

// 🔹 9. CAMBIAR CONTRASEÑA
export const cambiarContraseña = async (contraseñaActual, nuevaContraseña, confirmarNuevaContraseña) => {
  try {

    const respuesta = await fetch(`${API_URL}/cambiar-contrasena`, {
      method: "POST",
      headers: headersConToken(),
      credentials: "include", // ✅ Cookie
      body: JSON.stringify({
        contraseñaActual,
        nuevaContraseña,
        confirmarNuevaContraseña,
      }),
    });
    
    const data = await respuesta.json();
    if (!respuesta.ok) throw new Error(data.error || "Error al cambiar la contraseña");

    return data;
  } catch (error) {
    console.error("Error en cambiarContraseña:", error);
    return { error: error.message };
  }
};
export const resetPassword = async (usuarioId, nuevaContraseña) => {
  try {
    const response = await fetch(`${API_URL}/reset-password/${usuarioId}`, {
      method: "POST",
      headers: headersConToken(),
      credentials: "include", // ✅ Cookie
      body: JSON.stringify({ nuevaContraseña }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Error al restablecer la contraseña");
    return data;
  } catch (error) {
    console.error("Error en resetPassword:", error);
    return { error: error.message };
  }
};

/*OBTENER CURSOS*/

export const obtenerCursoPorId = async (id) => {
  try {
    const response = await fetch(`${API_URL}/cursos/${id}`, {
      credentials: "include" // ✅ Cookie
    });

    if (response.status === 403) {
      return { error: "no-autorizado" }; // 👈 Devuelve un error controlado
    }

    if (!response.ok) {
      throw new Error("No se pudo obtener el curso");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error en obtenerCursoPorId:", error);
    return null;
  }
};

/**
 * Syllabus + tabs for enrolled students (includes contenido). Public GET /cursos/:id does not.
 */
export const obtenerMiTemarioCurso = async (cursoId, options = {}) => {
  return getStudentCourseTemario(cursoId, options);
};
